// Supabase Auth utilities - replacing custom authentication
import { supabase } from '../supabaseClient';

export async function signInAdmin(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });

  if (error) {
    throw error;
  }

  return data;
}

export async function signOutAdmin() {
  const { error } = await supabase.auth.signOut();
  if (error) {
    throw error;
  }
}

export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}

export async function getCurrentSession() {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
}

export async function isAdminAuthenticated() {
  try {
    const session = await getCurrentSession();
    return !!session?.user;
  } catch (error) {
    console.error('Error checking auth:', error);
    return false;
  }
}

// For backward compatibility
export async function createAdminSession() {
  throw new Error('createAdminSession is deprecated. Use signInAdmin instead.');
}

export function logoutAdmin() {
  return signOutAdmin();
}

export function extendAdminSession() {
  // Supabase handles session refresh automatically
  return true;
}
